export default "__VITE_ASSET__98ttGBHO_8rp2VSeepp6PQ__"